/** @jsx h */
import { h } from 'preact'
import Dynamic from '../components/dynamic-html'
import Page from '../components/page'
import { PageCrate } from '../components/crate'

export default ({
  url,
  width = 7,
  shadow = true,
  backgroundColor = 'white'
}) => () => (
  <Page>
    <PageCrate width={width} shadow={shadow} backgroundColor={backgroundColor}>
      <Dynamic url={url} />
    </PageCrate>
  </Page>
)
